/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { FC, useRef, useState } from 'react';

import { useTheme } from 'styled-components';

import { Container } from './styles';
import { Typography } from '../Typography';
import { Button } from '../Button';

interface IConfirmationModalProps {
  onConfirm: () => Promise<void>;
  onAbort: () => void;
  text: string;
}
export const ConfirmationModal: FC<IConfirmationModalProps> = ({
  onConfirm,
  onAbort,
  text: initialText,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const theme = useTheme();
  const text = useRef<string>(initialText);

  const handleConfirm = async () => {
    setLoading(true);
    await onConfirm().finally(() => {
      setLoading(false);
    });
  };

  return (
    <Container>
      <Typography.Paragraph size="medium">{text.current}</Typography.Paragraph>

      <footer>
        <Button
          text="Cancelar"
          width="100%"
          justifyContent="center"
          backgroundColor={theme.transparent}
          borderColor={theme.green[500]}
          textOrIconColor={theme.green[500]}
          onClick={onAbort}
        />

        <Button
          text="Confirmar"
          width="100%"
          justifyContent="center"
          onClick={handleConfirm}
          loading={loading}
        />
      </footer>
    </Container>
  );
};
